import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { usePermission, clearAccessSnapshot } from '../../core/utils/PermissionContext';
import { loginRequest } from '../../auth/msal';

/**
 * Shown when the signed-in user has no authorized page, or access could not be loaded.
 * Never redirects automatically, so it cannot loop (PRD Screen 8).
 */
const NoAccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { instance, accounts } = useMsal();
  const { status, landingRoute, reload } = usePermission();

  const loadFailed = status === 'error' || location.state?.reason === 'error';
  const signedIn = accounts && accounts.length > 0;

  const handleRetry = async () => {
    const me = await reload();
    if (me?.landingRoute) navigate(me.landingRoute, { replace: true });
  };

  const handleSignIn = () => {
    clearAccessSnapshot();
    instance.loginRedirect({ ...loginRequest });
  };

  return (
    <div className="main-wrapper">
      <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh', padding: 16 }}>
        <div className="card p-4" style={{ maxWidth: 520, width: '100%' }}>
          <h4 className="mb-2">{loadFailed ? 'We could not load your access' : 'No access assigned'}</h4>
          {!signedIn ? (
            <p className="text-muted">Your session has ended. Please sign in again.</p>
          ) : loadFailed ? (
            <p className="text-muted">
              The access service did not respond. Check your connection and try again. If this keeps
              happening, contact IT support.
            </p>
          ) : (
            <p className="text-muted">
              Your account is signed in but has no application pages assigned. Ask your IT
              administrator to assign the correct application role in Microsoft Entra.
            </p>
          )}
          <div className="d-flex gap-2 mt-2 flex-wrap">
            {signedIn && (
              <button type="button" className="btn btn-primary" onClick={handleRetry}>
                Try again
              </button>
            )}
            {signedIn && landingRoute && !loadFailed && (
              <button type="button" className="btn btn-outline-primary" onClick={() => navigate(landingRoute)}>
                Go to my home page
              </button>
            )}
            <button type="button" className="btn btn-outline-secondary" onClick={handleSignIn}>
              Sign in again
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoAccess;
